import React from 'react'
import { Table } from 'antd'
import { getFullDate } from "./../util";

export default function Datatable({ data }) {

    const columns = [
        {
            title: "Email",
            dataIndex: "email"
        },
        {
            title: "Date",
            dataIndex: "createdAt",
            render: ((date) => getFullDate(date))
        }
    ]
    return (
        <>
            <Table
                dataSource={data}
                columns={columns}
                rowKey={(record => record._id)}
                style={{ overflowY: 'auto', height: '77vh', overflowX: 'hidden' }}

            >

            </Table>
        </>
    )
}

